import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const FriendsContainer = styled.div`
  margin-bottom: 25px;
  .accordion {
    .accordion-toggler {
      color: ${colors.dark7};
      background: ${colors.white};
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 50px;
      .toggler-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        h3 {
          font-size: 28px;
        }
        .icon-option:hover {
          opacity: 0.7;
        }
        .header-icon {
          width: 52px;
          height: 36px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: ${colors.dark7};
          margin-bottom: 20px;
        }
        .hide-checkbox {
          margin-left: 20px;
          label {
            margin-bottom: 0;
            color: white;
            line-height: 20px;
          }
        }
      }
    }
  }

  .modal-roles-wrapper {
    .modal-roles {
      display: flex;
      flex-direction: column;
      padding: 12px 12px 0 12px;
      .ant-radio-group {
        padding: 8px 16px;
        .ant-space {
          width: 100%;
          .ant-space-item {
            .ant-radio-wrapper {
              border: 1px solid ${colors.blueDark};
              border-radius: 15px;
              margin-right: 0;
              padding: 0 12px;
              align-items: center;
              height: 30px;
              width: 100%;
              &.ant-radio-wrapper-checked {
                background: ${colors.blueDark4};
              }
              .ant-radio-checked .ant-radio-inner {
                border-color: ${colors.blueDark};
                &::after {
                  background-color: ${colors.blueDark};
                }
              }
            }
          }
        }
      }
      .description {
        height: 140px;
        padding: 8px;
      }
      .actions {
        padding: 8px;
        display: flex;
        justify-content: space-between;
        .btn {
          width: 110px;
        }
      }
    }
  }

  .collapse {
    background: white;
  }

  @media (min-width: 901px) {
    .accordion-friend {
      padding: 0 32px !important;
    }
  }

  @media (max-width: 900px) {
    .modal-roles-wrapper {
      .modal-custom-body {
        background-color: white !important;
      }
    }
  }

  @media (max-width: ${breakpoints.sm}px) {
  }
  @media (max-width: 413px), (max-height: 845px) {
  }

  // Here modal style...
  .modal-roles-wrapper {
    .ant-modal-content {
      .ant-modal-close {
        color: white !important;
        margin-top: -3.5px;
      }

      .ant-modal-header {
        background-color: #4c4c4c;

        .ant-modal-title {
          color: white !important;
        }
      }

      .ant-modal-body {
        background-color: #f4f3f3;
      }

      .modal-custom-body {
        background-color: white;
        border-radius: 15px;

        h4 {
          text-align: center !important;
        }
      }

      .modal-custom-footer {
        padding: 24px 0 0 0 !important;

        .actions {
          padding: 8px 0 !important;

          .green {
            background-color: #4e9e69 !important;
            border-color: #4e9e69 !important;
            color: white !important;
          }

          .gray {
            background-color: #4c4c4c !important;
            border-color: #4c4c4c !important;
            color: white !important;
          }
        }
      }
    }
  }
`

export const FilterContainer = styled.div`
  height: ${(props) => (props.showFilter ? 40 : 0)}px;
  transition: all 0.5s ease-in-out;
  background-color: #dddddd;
  width: 100%;
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 0 5px;
`

export const AnswerItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  .icon-camera,
  .icon-view,
  .icon-pen {
    width: 35px;
    min-width: 35px;
    text-align: center;
    svg:hover {
      opacity: 0.7;
    }
  }
  h6 {
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.4px;
    margin-bottom: 0;
  }
  @media (max-width: ${breakpoints.sm}px) {
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
